import { FC, ReactNode, useState } from 'react';
import classNames from 'classnames';
// Import Styles
import styles from './MarkDownReader.module.scss';

interface Props {
    question?: string;
    children?: ReactNode;
    /** The Markdown lines of the block, when the reader marks them for an editor. */
    // eslint-disable-next-line @typescript-eslint/naming-convention -- the HTML attribute react-markdown sets
    'data-sourcepos'?: string;
}

/**
 * Renders the custom "qa" hast node produced by remarkAlerts.
 * The question is plain text from the directive attribute; the answer
 * (children) is regular rendered Markdown, hidden until expanded.
 */
const QA: FC<Props> = ({ question = 'Question', children, 'data-sourcepos': sourcePos }) => {
    const [open, setOpen] = useState(false);

    return (
        <div
            className={classNames(styles.qa, {
                [styles.qaOpen]: open,
            })}
            data-sourcepos={sourcePos}
        >
            <button type="button" className={styles.qaQuestion} onClick={() => setOpen((o) => !o)} aria-expanded={open}>
                <svg
                    className={styles.qaChevron}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="var(--custom-color-1)"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.46967 4.21967C8.17678 4.51256 8.17678 4.98744 8.46967 5.28033L15.1893 12L8.46967 18.7197C8.17678 19.0126 8.17678 19.4874 8.46967 19.7803C8.76256 20.0732 9.23744 20.0732 9.53033 19.7803L16.7803 12.5303C17.0732 12.2374 17.0732 11.7626 16.7803 11.4697L9.53033 4.21967C9.23744 3.92678 8.76256 3.92678 8.46967 4.21967Z"
                        fill="var(--custom-color-1)"
                    />
                </svg>
                <span className={styles.qaQuestionText}>{question}</span>
            </button>
            {open && <div className={styles.qaAnswer}>{children}</div>}
        </div>
    );
};

export default QA;
